/* eslint-disable import/no-extraneous-dependencies */
import { BrowserRouter } from 'react-router-dom';
import { createBrowserHistory } from 'history';

export const browserHistory = createBrowserHistory();

// Expose the app's history when running under Cypress so specs can navigate the SPA without a full reload.
if (window.Cypress) window.browserHistory = browserHistory;

class Router extends BrowserRouter {
  public history = browserHistory;
}

export default Router;
